// extracted by mini-css-extract-plugin
module.exports = {"main":"Notifications_main__35v8r","box":"Notifications_box__hVAa8"};